import { render, staticRenderFns } from "./ComprovantesItem.vue?vue&type=template&id=45cd0b6e&"
import script from "./ComprovantesItem.vue?vue&type=script&lang=ts&"
export * from "./ComprovantesItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports